import { render, staticRenderFns } from "./VisitorApplyPage.vue?vue&type=template&id=5c64d9c9&scoped=true&"
import script from "./VisitorApplyPage.vue?vue&type=script&lang=js&"
export * from "./VisitorApplyPage.vue?vue&type=script&lang=js&"
import style0 from "./VisitorApplyPage.vue?vue&type=style&index=0&id=5c64d9c9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64d9c9",
  null
  
)

export default component.exports